module.exports = __webpack_public_path__ + "static/media/Maf_21Mayo.93b20f03.jpg";